export * from './register.component';
export * from './mailVerificationComponent';
